export enum Routes {
  CommerceRouter = '/commerce/*',
  MyChannelsPage = 'my-channels',
}
